export default function isFormTemplateQuestionDropdownOrSelect(questionType: string) {
    return (
        questionType === "GqlSettingsFormTemplateQuestionTypeDropdown" ||
        questionType === "GqlSettingsFormTemplateQuestionTypeSelect"
    );
}
